import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import * as serviceWorker from './serviceWorker';

import theme from './theme';
import { ThemeProvider } from '@material-ui/core/styles';

ReactDOM.render(
  <React.Fragment>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: registration => {
    // Dispatch an event so the app can show an update prompt
    const event = new CustomEvent('swUpdated', { detail: registration });
    window.dispatchEvent(event);
  }
});
// serviceWorker.unregister();
